var $name="allowOrigin",$path="app/utilities/allowOrigin.js",$this={$name,$path,};/**
 * @param { string } origin
 * @returns { boolean }
 */
const allowOrigin = (origin) => origin === window.location.origin;

export default allowOrigin;
